<template>
  <div class="container">
    <div class="right">
      <el-row class="flex-list">
        <el-col :span="4">
          <el-input
            size="small"
            clearable
            placeholder="请输入用户名或手机号"
            prefix-icon="el-icon-search"
            v-model="lexicons.keyword"
            @input="handInput"
            @clear="clear"
          >
          </el-input>
        </el-col>
        <el-col :span="4" :offset="1">
          <el-input
            size="small"
            clearable
            placeholder="请输入流程名称"
            prefix-icon="el-icon-search"
            @input="handInput"
            v-model="lexicons.keyword1"
            @clear="clear"
          >
          </el-input>
        </el-col>
        <el-col :span="4" :offset="2">
          <el-button @click="handLeClick" size="small" :disabled="disabled"
            >搜索</el-button
          >
        </el-col>
      </el-row>
      <div  class="distance">
        <el-table :data="tableData">
          <el-table-column
            prop="user.name"
            label="用户名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="flow"
            label="流程名称名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="type"
            label="操作类型"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="remark"
            label="操作备注"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间">
          </el-table-column>
          <el-table-column prop="updated_at" label="更新时间">
          </el-table-column>
        </el-table>
      </div>
      <pagingVue
        :Pagination="Pagination"
        :tableData="tableData"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagingVue>
    </div>
  </div>
</template>
  
  <script>
  import pagingVue from '../../../components/Paging/paging.vue';
export default {
  name: "",

  data() {
    return {
      disabled: true,
      lexicons: {
        keyword: "",
        keyword1: "",
        page: "1",
      },
      tableData: [],
      Pagination: {},
    };
  },

  components: {
    pagingVue
  },

  computed: {},

  created() {
    this.recordsData();
  },

  mounted() {},

  methods: {
    handInput() {
      if (this.lexicons.keyword == "" && this.lexicons.keyword1 == "") {
        this.disabled = true;
      } else if (this.lexicons.keyword == "" && this.lexicons.keyword1 != "") {
        this.disabled = false;
      } else if (!this.lexicons.keyword == "" && this.lexicons.keyword1 == "") {
        this.disabled = false;
      } else {
        this.disabled = false;
      }
    },
    handLeClick() {
      this.recordsData();
    },
    clear() {
      this.recordsData();
    },
    handleSizeChange(val) {
      console.log(val);
    },
    async recordsData() {
      const res = await this.$axios.getListData(
        "admin/mobile-activity-logs",
        this.lexicons
      );
      if (res.code == 200) {
        console.log(res);
        this.Pagination = res.data.meta.pagination;
        let item = res.data.data;
        this.tableData = item.map((v) => {
          return {
            ...v,
            type:
              v.type == 1
                ? "继续"
                : v.type == 2
                ? "暂停"
                : v.type == 3
                ? "结束"
                : "开始",
            flow: v.flow ? v.flow.name : "——",
            created_at: this.$inserted(v.created_at),
            updated_at: this.$inserted(v.updated_at),
          };
        });
      }
    },
    handleCurrentChange(val) {
      console.log(val);
      this.lexicons.page = val;
      this.recordsData();
    },
  },
};
</script>
  <style lang='less' scoped>
/deep/.cell {
  max-height: 28px !important;
}
/deep/.el-table__empty-text {
  line-height: 53px;
}
/deep/.el-table__empty-block {
  min-height: 53px;
}
.el-message-box__close .el-icon-close {
  display: none !important;
}
.distance {
  margin: 10px 0;
}
/deep/.el-button--small{
  padding: 10px 20px;
}
.container {
  width: 100%;
  box-sizing: border-box;
  padding: 30px;
  overflow: hidden;
  .right {
    width: 100%;
    .flex-list {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }

    
  }
}
</style>